import BaseError from '../../components/errors/BaseError'

export default function Denied() {
  const msg = `Access denied. If you feel this is in error please contact customer support.`
  return (
    <>
      <BaseError
        onClose={() => {}}
        header="Access denied"
        message={<span dangerouslySetInnerHTML={{ __html: msg }} />}
      />
    </>
  )
}
